module.exports = __webpack_public_path__ + "dist/images/4c9e91a0d0f920af463bed629b76f9d5.png";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/full-page-error/page-monster.png
// module id = 468
// module chunks = 0